// extracted by mini-css-extract-plugin
export default {"Box":"table-cell-module__Box--j8lgr","StyledTableCell":"table-cell-module__StyledTableCell--BR94N"};